module.exports = __webpack_public_path__ + "static/media/data_4.26887d66.mp4";